/* istanbul ignore file */ // not fully implemented yet
import React, { useCallback, useContext, useState } from 'react';
import { Label } from '@fluentui/react-components';
import {
  BannerServiceProvider,
  CopilotRecommendationBanner,
  CopilotRepositoryProvider,
  CopilotThemesRecommendationDialog,
} from '@bingads-webui/inline-copilot';
import { useRecommendations } from '@bingads-webui-campaign-react/perf-max-recommendation';
import PropTypes from 'prop-types';
import { useStyles } from './style';
import { FinalUrl } from './final-url';
import { DisplayAdsContext } from '../../context';
import { ActionTypes } from '../../reducer';

export const RecommendationsBanner = (props) => {
  const {
    i18n,
    serverContext,
    perfMarker,
    finalUrl,
    setFinalUrl,
    handleOnFetchSucceeded,
    aid,
    cid,
    permissions,
    instrumentation,
  } = props;
  const classes = useStyles();
  const [showCopilotDialog, setShowCopilotDialog] = useState(false);
  const [lastFetchedUrl, setLastFetchedUrl] = useState('');
  const {
    dispatch,
  } = useContext(DisplayAdsContext);
  const {
    CurrentLocale: locale,
  } = serverContext;

  const {
    handleCopilotBannerFetchSucceeded,
  } = useRecommendations({
    cid,
    aid,
    campaignId: -1,
    permissions,
    finalUrl,
    isDisplayPlus: false,
    enableCopilotRecommendations: true,
    instrumentation,
    isMMA: false,
    isSignup: false,
    skipBusinessNameRecommendation: true,
  });

  const onFetch = useCallback((url) => {
    if (lastFetchedUrl !== url) {
      dispatch({ type: ActionTypes.updateAssetLoading, payload: true });
    }
  }, [dispatch, lastFetchedUrl]);

  const onFetchFailed = useCallback(() => {
    dispatch({ type: ActionTypes.updateAssetLoading, payload: false });
  }, [dispatch]);

  const onFetchSucceeded = useCallback((url, assetsResponse, isRefinedRecommendation = false) => {
    const urlChanged = lastFetchedUrl !== url;
    const shouldRefreshRecommendations = (urlChanged || isRefinedRecommendation) && !!assetsResponse;

    if (shouldRefreshRecommendations) {
      handleOnFetchSucceeded(assetsResponse);
      handleCopilotBannerFetchSucceeded(url, assetsResponse);
      setLastFetchedUrl(url);
      return;
    }

    dispatch({ type: ActionTypes.updateAssetLoading, payload: false });
  }, [lastFetchedUrl, dispatch, handleOnFetchSucceeded, handleCopilotBannerFetchSucceeded]);

  const handleCopilotDialogClose = useCallback(() => setShowCopilotDialog(false), []);

  const handleFetchAssetsSucceeded = useCallback((url, assetsRecommendationData) => {
    onFetchSucceeded(url, assetsRecommendationData, true);
    handleCopilotBannerFetchSucceeded(url, assetsRecommendationData);
  }, [onFetchSucceeded, handleCopilotBannerFetchSucceeded]);

  const handleRefresh = useCallback(() => setShowCopilotDialog(true), []);
  const copyOverrides = {
    description: i18n.getString(_TL_('Choose the themes you\'d like to add to your display template.')),
  };

  return (
    <CopilotRepositoryProvider
      campaignId={-1}
      recommendationType="Display"
      finalUrl={finalUrl}
      serverContext={serverContext}
      perfMarker={perfMarker}
      locale={locale}
      enableLogoAndCTA
    >
      <BannerServiceProvider>
        <div className={classes.finalUrlContainer}>
          <Label htmlFor="final-url">{i18n.getString(_TL_('Generate assets from your URL'))}</Label>
          <FinalUrl
            i18n={i18n}
            finalUrl={finalUrl}
            setFinalUrl={setFinalUrl}
          />
        </div>
        <CopilotRecommendationBanner
          className={classes.copilotBanner}
          narrow
          isToastEnabled
          onRefresh={handleRefresh}
          onReset={() => {}}
          toastOffset={{ horizontal: 260, vertical: 120 }}
          onFetch={onFetch}
          shouldFetchRecommendations
          onFetchFailed={onFetchFailed}
          onFetchSucceeded={onFetchSucceeded}
          copyOverrides={copyOverrides}
        />
        {showCopilotDialog &&
          <CopilotThemesRecommendationDialog
            open
            onClosed={handleCopilotDialogClose}
            onFetchAssetsSucceeded={handleFetchAssetsSucceeded}
            onApply={() => {}}
          />
        }
      </BannerServiceProvider>
    </CopilotRepositoryProvider>
  );
};

RecommendationsBanner.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({
    CurrentLocale: PropTypes.string,
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  finalUrl: PropTypes.string,
  setFinalUrl: PropTypes.func.isRequired,
  handleOnFetchSucceeded: PropTypes.func.isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  permissions: PropTypes.shape({}).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
};

RecommendationsBanner.defaultProps = {
  finalUrl: '',
};
